<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>
  <!-- FILTROS -->
  <!-- Periodo actual  -->
  <app-filters filtros
    [array]="Periodos"
    [typeFilter]="Filtros.PERIOD"
    [name]="'filtros.perActual' | translate"
    (eventClick)="periodoChangeListener($event)"
    [click]="true"
  ></app-filters>
<!-- Periodo anterior -->
  <app-filters filtros
    [array]="Periodos2"
    [typeFilter]="Filtros.PERIOD"
    [name]="'filtros.perAnterior' | translate"
    (eventClick)="periodo2ChangeListener($event);"
    [click]="true"
  ></app-filters>
  <!-- CONSOLIDADO Y SUCURSALES -->
   <!-- El filtro de sucursales pareciera que ya no se utiliza por eso no lo pase -->
  @if (puedeFiltrarPorSucursales) {
    <div class="w3-third">
      <div class="w3-half hijoizquierda">
        Entidad
        <button class="w3-button w3-tiny"  [matMenuTriggerFor]="menuentidad">
          <mat-icon class="w3-medium">expand_more</mat-icon>
        </button>
        <mat-menu class="w3-tiny"  #menuentidad="matMenu" >
          <button mat-menu-item>
            <mat-checkbox name="consolidado" [checked]=""
                          (click)="$event.stopPropagation();"
                          (change)="consolidadoChangeListener()"
                          aria-label="First checkbox">
              Consolidado
            </mat-checkbox>
          </button>
          <button mat-menu-item  [matMenuTriggerFor]="sucursales">Sucursales</button>
        </mat-menu>
        <mat-menu #sucursales="matMenu">
          @for (sucursal of sucursalesDisponibles; track $index) {
            <button mat-menu-item>
              <mat-checkbox [checked]="sucursal.check"
                (change)="sucursalChangeListener(sucursal)"
                (click)="$event.stopPropagation();">
                {{sucursal.name}}
              </mat-checkbox>
            </button>
          }                  
        </mat-menu>
      </div>
      <div class="w3-rest">
        <div class="w3-row padreizquierda">
          <div class="w3-row hijoizquierda ">
            @if (sucursalSeleccionada) {
              <div [ngClass]="'w3-round-btn-large w3-gris-btn w3-show w3-left w3-center w3-elemento-menu'"
                class="filtroMesAnioSeleccionado">
                {{sucursalSeleccionada}}
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }  
  <div borrador>
    <div class="w3-button w3-dropdown-click" style="transform: scale(0.9);" [ngStyle]="{'color':'gray'}"
      matTooltip="{{'tooltips.borrar-filtros'|translate}}" (click)="quitarFiltros()">
      <img src="./../../../../assets/img/eraser.png">
    </div>
  </div>
  <!-- CONTENIDO -->
  <div contenido class="zonaContenido">
    <div class="zona">
      <app-contenedor-elementos class="zonaTabla"
      [header]="{title: 'riesgo-credito.matriz.enc1' | translate, subtitles: [ {text:subtituloGrafica}]}">
        <mat-icon iconos class="iconoMen margenDer" [ngStyle]="{'color':'gray'}" 
          (click)="Ampliar(1)">zoom_out_map</mat-icon>
        <mat-icon iconos [ngStyle]="{'color':'gray'}" [matMenuTriggerFor]="menuP2">more_vert</mat-icon>
        <mat-menu #menuP2="matMenu" xPosition="before">
          <div mat-menu-item [matMenuTriggerFor]="menu.perspectivas" #trigger="matMenuTrigger">
            <mat-icon [ngStyle]="{'color':'gray'}" class="material-icons-outlined">account_tree</mat-icon>
            {{'filtros.pers' | translate}}
          </div>
          <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="menuMetrica">
            <mat-icon [ngStyle]="{'color':'gray'}">tag</mat-icon>
            <span>{{'menu.Metrica' | translate}}</span>
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="exportar_csv('monto')">
            <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
            <span>{{'menu.Exportar' | translate}}</span>
          </button>
        </mat-menu>
        <app-menu-perspectivas #menu 
          [tipo]="submenus" 
          [tablero]="'matriz'"
          (eventClick)="filterChange($event);">
        </app-menu-perspectivas>
        <mat-menu #menuMetrica="matMenu">
          <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled':metrica === 'general'}" [disabled]="metrica === 'general'" (click)="cambioMetrica('general')">
            <span>{{'riesgo-credito.matriz.metrica1'|translate}}</span>
          </button>
          <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled':metrica === 'categoria'}" [disabled]="metrica === 'categoria'" (click)="cambioMetrica('categoria')">
            <span>{{'riesgo-credito.matriz.metrica2'|translate}}</span>
          </button>
          <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled':metrica === 'total'}" [disabled]="metrica === 'total'" (click)="cambioMetrica('total')">
            <span>{{'riesgo-credito.matriz.metrica3'|translate}}</span>
          </button>
        </mat-menu>
        <div body class="tabla">
          @if (periodoActual) {
            <div class="w3-row w3-center">{{periodoActual.mes}} &bull; {{periodoActual.an}}</div>
          }
          <div class="w3-row" style="height: 100%; display: flex; flex-direction: row;">
            @if(periodoAnterior){
              <div class="mesVertical">{{periodoAnterior.mes}} &bull; {{periodoAnterior.an}}</div>
            }
            <div class=" w3-scroll" style="height: 32vh; width: 100%;">
              @if(dataMatriz1.length > 0){
                <table class="tabla-aleema">
                  <thead>
                    <tr class="w3-center">
                      <th class="w3-white"></th>
                      @for (r of dataMatriz1; track $index) {
                        <th>{{r[0]}}</th>
                      }               
                    </tr>
                  </thead>
                  <tbody>
                    @for (d of dataMatriz1; track d; let i = $index) {
                      <tr class="w3-center">
                        @for (n of d; track n; let j = $index) {
                          @if(j===0){
                            <td class="w3-table-titleLow">{{n}}</td>
                          } @else if(metrica === 'general' || metrica === 'total'){
                            @if (j == d.length-1 || i == dataMatriz1.length-1) {
                              <td>{{n | formaterNumber:2:miles:decimal}}@if(metrica === 'total'){%}</td>
                            }@else {
                              @if (n.value != 0) {
                                <td [style.cursor]="!filtroActivado ? 'pointer' : 'default'" [class]="PintarCelda(j-1,i)" (dblclick)="!filtroActivado && getCuentas(n)"
                                  [matTooltip]="!filtroActivado ? ('tooltips.tooltipDbclick' | translate) : ''">
                                  {{n.value | formaterNumber:2:miles:decimal}}
                                  @if(metrica === 'total'){%}
                                </td>
                              }           
                              @else {<td [class]="PintarCelda(j-1,i)"></td>}
                            }  
                          } @else if(metrica === 'categoria'){
                            @if (n.value != 0) {
                              <td [style.cursor]="!filtroActivado ? 'pointer' : 'default'" [class]="PintarCelda(j-1,i)" (dblclick)="!filtroActivado && getCuentas(n)"
                                [matTooltip]="!filtroActivado ? ('tooltips.tooltipDbclick' | translate) : ''">{{n.value | formaterNumber:2:miles:decimal}} %</td>
                            }           
                            @else {<td [class]="PintarCelda(j-1,i)"></td>}
                          }                   
                        }                      
                      </tr>
                    }
                  </tbody>
                </table>
              }@else{<app-skeleton-table [columnas]="13" [filas]="6"/>}              
            </div>
          </div>
        </div>
      </app-contenedor-elementos>
      <div class="zonaTarjetas">
        <div class="tarjeta">
          @if(total_abajodiagonal){
            <app-tarjetas [header]="'riesgo-credito.matriz.tarj1' | translate" 
            [valueStr]="moneda + (metrica === 'general'
              ? (total_abajodiagonal | formaterNumber:0:miles:decimal)
              : (total_abajodiagonal | formaterNumber:2:miles:decimal) + '%')" 
            [footer]="mesAnio" [showIcon]="true" [iconFirst]="true" [icon]="'thumb_up'" [color]="'#8bc34a'"
            [alto]="'12.3vh'" [siceHeader]="'2.5vh'" [siceValue]="'3vh'" [siceFooter]="'2vh'" [sice]="'3vh'"/>
          }@else{<app-skeleton-card/>}
        </div>
        <div class="tarjeta">
          @if(total_diagonal){
            <app-tarjetas [header]="'riesgo-credito.matriz.tarj2' | translate" 
            [valueStr]="moneda + (metrica === 'general'
              ? (total_diagonal | formaterNumber:0:miles:decimal)
              : (total_diagonal | formaterNumber:2:miles:decimal) + '%')" 
            [footer]="mesAnio" [showIcon]="true" [iconFirst]="true" [icon]="'touch_app'" [color]="'#0075C9'"
            [alto]="'12.3vh'" [siceHeader]="'2.5vh'" [siceValue]="'3vh'" [siceFooter]="'2vh'" [sice]="'3vh'"/>
          }@else{<app-skeleton-card/>}
        </div>
        <div class="tarjeta">
          @if(total_arribadiagonal){
            <app-tarjetas [header]="'riesgo-credito.matriz.tarj3' | translate" 
            [valueStr]="moneda + (metrica === 'general'
              ? (total_arribadiagonal | formaterNumber:0:miles:decimal)
              : (total_arribadiagonal | formaterNumber:2:miles:decimal) + '%')" 
            [footer]="mesAnio" [showIcon]="true" [iconFirst]="true" [icon]="'thumb_down'" [color]="'#ff9012'"
            [alto]="'12.3vh'" [siceHeader]="'2.5vh'" [siceValue]="'3vh'" [siceFooter]="'2vh'" [sice]="'3vh'"/>
          }@else{<app-skeleton-card/>}
        </div>        
      </div>   
    </div>
    <div class="zona">
      <app-contenedor-elementos class="zonaTabla"
        [header]="{title: 'riesgo-credito.matriz.enc2' | translate, subtitles: [ {text:subtituloGraficaII}]}">
        <mat-icon iconos class="iconoMen margenDer" [ngStyle]="{'color':'gray'}" (click)="Ampliar(2)">zoom_out_map</mat-icon>
        <mat-icon iconos [ngStyle]="{'color':'gray'}" [matMenuTriggerFor]="menuP3">more_vert</mat-icon>
        <mat-menu #menuP3="matMenu" xPosition="before">
          <button mat-menu-item (click)="exportar_csv('creditos')">
            <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
            <span>{{'menu.Exportar' | translate}}</span>
          </button>
        </mat-menu>
        <div body class="tabla">
          @if (periodoActual) {
            <div class="w3-row w3-center">{{periodoActual.mes}} &bull; {{periodoActual.an}}</div>
          }
          <div class="w3-row" style="height: 87%; display: flex; flex-direction: row;">
            @if(periodoAnterior){
              <div class="mesVertical">{{periodoAnterior.mes}} &bull; {{periodoAnterior.an}}</div>
            }
            <div class="w3-scroll" style="height: 29vh; width: 100%;">
              @if(dataMatriz2.length > 0){
                <table class="tabla-aleema">
                  <thead>
                    <tr class="w3-center">
                      <th></th>
                      @for (r of dataMatriz2; track $index) {
                        <th class="w3-table-titleLow">{{r[0]}}</th>
                      }               
                    </tr>
                  </thead>
                  <tbody>
                    @for (d of dataMatriz2; track d; let i = $index) {
                      <tr class="w3-center">
                        @for (n of d; track n; let j = $index) {
                          @if(j===0){
                            <td class="w3-table-titleLow borderAllLow" style="max-width: 1vw !important;">{{n}}</td>
                          } @else {
                            @if (n != 0) {
                              <td>
                                {{n | formaterNumber:0:miles:decimal}}
                                @if(metrica !== 'general'){%}
                              </td>
                            }@else {<td></td>}
                          }                        
                        }                      
                      </tr>
                    }
                  </tbody>
                </table>
              }@else{<app-skeleton-table [columnas]="13" [filas]="6"/>}              
            </div>
          </div>     
        </div>
      </app-contenedor-elementos>
      <div class="zonaTarjetas">
        <div class="tarjeta">
          @if(total_abajodiagonalII){
            <app-tarjetas [header]="'riesgo-credito.matriz.tarj4' | translate" 
            [valueStr]="moneda + (metrica === 'general'
              ? (total_abajodiagonalII | formaterNumber:0:miles:decimal)
              : (total_abajodiagonalII | formaterNumber:2:miles:decimal) + '%')" 
            [footer]="mesAnio" [showIcon]="true" [iconFirst]="true" [icon]="'thumb_up'" [color]="'#8bc34a'"
            [alto]="'12.3vh'" [siceHeader]="'2.5vh'" [siceValue]="'3vh'" [siceFooter]="'2vh'" [sice]="'3vh'"/>
          }@else{<app-skeleton-card/>}
        </div>
        <div class="tarjeta">
          @if(total_diagonalII){
            <app-tarjetas [header]="'riesgo-credito.matriz.tarj5' | translate" 
            [valueStr]="moneda + (metrica === 'general'
              ? (total_diagonalII | formaterNumber:0:miles:decimal)
              : (total_diagonalII | formaterNumber:2:miles:decimal) + '%')" 
            [footer]="mesAnio" [showIcon]="true" [iconFirst]="true" [icon]="'touch_app'" [color]="'#0075C9'"
            [alto]="'12.3vh'" [siceHeader]="'2.5vh'" [siceValue]="'3vh'" [siceFooter]="'2vh'" [sice]="'3vh'"/>
          }@else{<app-skeleton-card/>}
        </div>
        <div class="tarjeta">
          @if(total_arribadiagonalII){
            <app-tarjetas [header]="'riesgo-credito.matriz.tarj6' | translate" 
            [valueStr]="moneda + (metrica === 'general'
              ? (total_arribadiagonalII | formaterNumber:0:miles:decimal)
              : (total_arribadiagonalII | formaterNumber:2:miles:decimal) + '%')" 
            [footer]="mesAnio" [showIcon]="true" [iconFirst]="true" [icon]="'thumb_down'" [color]="'#ff9012'"
            [alto]="'12.3vh'" [siceHeader]="'2.5vh'" [siceValue]="'3vh'" [siceFooter]="'2vh'" [sice]="'3vh'"/>
          }@else{<app-skeleton-card/>}
        </div>        
      </div>  
    </div>
     
  </div>
</app-esqueleto-tableros>

<app-modal [isOpen]="modalOpen" (close)="cerrarModal()" [export]="true" [iconoExport]="'description'"
  (exportFile)=" !tablacuentas_modal 
  ? exportar_csv(tablamonto_modal?'monto':'creditos')
  : exportCuentasMatriz()">
  <div modal-header>
    <span class="w3-margin-left-contenido">{{titulomodal}}</span>
    <span class="w3-punto-subtitulo w3-margin-left-filter" >&bull;</span>
    <span class=" w3-margin-left-filter w3-subtitulo">{{subtitulomodal}}</span>
  </div>
  <div modal-body style="max-height: 70vh; width: 70vw; overflow: hidden;">
    @if(!tablacuentas_modal){
      @if (periodoActual) {
        <div class="w3-row w3-center">{{periodoActual.mes}} &bull; {{periodoActual.an}}</div>
      }
      <div class="w3-row" style="height: 98%; display: flex; flex-direction: row;">
        @if(periodoAnterior){
          <div class="mesVertical">{{periodoAnterior.mes}} &bull; {{periodoAnterior.an}}</div>
        }
        <div style="flex: 1; overflow-y: auto;">
          @if (tablamonto_modal) {
            <table class="tabla-aleema">
              <thead>
                <tr class="w3-center">
                  <th class="w3-white"></th>
                  @for (r of dataMatriz1; track $index) {
                    <th>{{r[0]}}</th>
                  }               
                </tr>
              </thead>
              <tbody>
                @for (d of dataMatriz1; track d; let i = $index) {
                  <tr class="w3-center">
                    @for (n of d; track n; let j = $index) {
                      @if(j===0){
                        <td class="w3-table-titleLow">{{n}}</td>
                      } @else if(metrica === 'general' || metrica === 'total'){
                        @if (j == d.length-1 || i == dataMatriz1.length-1) {
                          <td>{{formatearnormal(n.toFixed(2))}}@if(metrica === 'total'){%}</td>
                        }@else {
                          @if (n.value != 0) {
                            <td style="cursor: pointer;" [class]="PintarCelda(j-1,i)"  (dblclick)="getCuentas(n)"
                              matTooltip="{{'tooltips.tooltipDbclick' | translate}}">
                              {{formatearnormal(n.value)}}
                              @if(metrica === 'total'){%}
                            </td>}           
                          @else {<td [class]="PintarCelda(j-1,i)" ></td>}
                        } 
                      }@else if(metrica === 'categoria'){
                        @if (n.value != 0) {
                          <td [style.cursor]="!filtroActivado ? 'pointer' : 'default'" [class]="PintarCelda(j-1,i)" (dblclick)="!filtroActivado && getCuentas(n)"
                            [matTooltip]="!filtroActivado ? ('tooltips.tooltipDbclick' | translate) : ''">{{formatearnormal(n.value)}} %</td>
                        }           
                        @else {<td [class]="PintarCelda(j-1,i)"></td>}
                      }                            
                    }                      
                  </tr>
                }
              </tbody>
            </table>
          }            
          @if (tablacreditos_modal) {
            <table class="tabla-aleema">
              <thead>
                <tr class="w3-center">
                  <th></th>
                  @for (r of dataMatriz2; track $index) {
                    <th>{{r[0]}}</th>
                  }               
                </tr>
              </thead>
              <tbody>
                @for (d of dataMatriz2; track d; let i = $index) {
                  <tr class="w3-center">
                    @for (n of d; track n; let j = $index) {
                      @if(j===0){
                        <td class="w3-table-titleLow">{{n}}</td>
                      } @else {
                        @if (n != 0) {
                          <td [class]="PintarCelda(d,n-1)">
                              @if(metrica !== 'general'){%}{{n | formaterNumber:0:miles:decimal}}
                          </td>}           
                        @else {<td [class]="PintarCelda(d,n-1)"></td>}
                      }                        
                    }                      
                  </tr>
                }
              </tbody>
            </table>
          }        
        </div>
      </div>       
    }@else{
      <table class="tabla-aleema">
        <thead>
          <tr class="w3-center">
            <th>{{'riesgo-credito.matriz.tablaCuentasTitulo1' | translate}}</th>
            <th>{{'riesgo-credito.matriz.tablaCuentasTitulo2' | translate}}</th>
            <th>{{'riesgo-credito.matriz.tablaCuentasTitulo3' | translate}}</th>
            <th>{{'riesgo-credito.matriz.tablaCuentasTitulo4' | translate}}</th>
            <th>{{'riesgo-credito.matriz.tablaCuentasTitulo5' | translate}}</th>
            <th>{{'riesgo-credito.matriz.tablaCuentasTitulo6' | translate}}</th>
            <th>{{'riesgo-credito.matriz.tablaCuentasTitulo7' | translate}}</th>
            <th>{{'riesgo-credito.matriz.tablaCuentasTitulo8' | translate}}</th>
            <th>{{'riesgo-credito.matriz.tablaCuentasTitulo9' | translate}}</th>
          </tr>
        </thead>
        <tbody>
          @for (inf of dataClick; track $index) {          
            <tr class="w3-center">
              <td class="alinLeft"> {{ inf.nCredito?inf.nCredito:0 }} </td>
              <td class="alinLeft"> {{ inf.claveSocio }} </td>
              <td> {{ inf.sucursal }} </td>
              <td class="alinLeft"> {{ inf.nombre }} </td>
              <td class="alinRight"> {{ inf.diasMora }} </td>
              <td> {{ inf.tipoCred }} </td>
              <td> {{ inf.producto }} </td>
              <td class="alinRight"> {{ inf.saldo | formaterNumber:2:miles:decimal }} </td>
              <td class="alinLeft"> {{ inf.estatus }} </td>
            </tr>
          }
        </tbody>
      </table>
    }    
  </div>
 </app-modal>